export default "__VITE_ASSET__a87ce051__"